<template>
    <div>
        <h1 class="has-text-centered is-size-3 has-text-white">Admin Manager</h1>
        <div class="has-background-dvodark">
            <b-button class="is-dvogreen m-3"  @click="addAdminModal()">Add Admin</b-button>
            <b-table
                :data="data"
                :bordered="true"
                :striped="true"
                :loading="isLoading"
                >
                <b-table-column label="Admin Email"  v-slot="props">
                    {{ props.row.detail }}
                </b-table-column>
                <b-table-column label="Remove Privileges" v-slot="props">
                    <i @click="removeFromAdmin(props.row.Username)" class="far fa-trash-alt has-text-dvogreen"></i>
                </b-table-column>            
                <template #empty>
                    <div class="has-text-centered">No records</div>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import AddToAdmin from './AddToAdmin.vue'
import { API } from 'aws-amplify'
import { addToAdmin } from '../graphql/mutations'
import { removeFromAdmin } from '../graphql/mutations'

export default {
    components:{
        // AddToAdmin,
    },
    data(){
        return{
            data: [],
            isLoading: false,
            users: [],
            filteredUsers: [],
            selectedUser: null,
            isSending: false
        }
    },
    methods: {
        async removeFromAdmin(id) {
            this.isSending = true
            this.isLoading = true;
            await API.graphql({
                query: removeFromAdmin,
                variables: {
                    input: {
                    username: id
                    }
                }
            });
            this.isSending = false
            this.isLoading = false
            this.getAdmins()
        },
        async addAdminModal(){
            this.$buefy.modal.open({
                parent: this,
                component: AddToAdmin,
                hasModalCard: true,
                trapFocus: true,
                props: {

                },
                events: {
                    'close': () => {
                        this.getAdmins();
                    }
                }
            })
        },
        async getAdmins(){
        this.isLoading = true;
        try {
          let a = await API.graphql({
                query: addToAdmin,
                variables: {
                        input: {
                        username: "",
                        request_type:"list"
                        }
                    }
                })
            const temp = a.data.addToAdmin
            for(let i = 0; i < temp.length; i++){
                const isEmail = (element) => element.Name === "email";
                const emailIndex = temp[i].Attributes.findIndex(isEmail)
                temp[i].detail = temp[i].Attributes[emailIndex].Value
            }
            this.data = temp
  
        } catch (e) {
            this.$buefy.notification.open({
                duration: 5000,
                message: `${e}`,
                position: 'is-bottom',
                type: 'is-danger',
                hasIcon: true
            })
        }
        this.isLoading = false
        }
    },
    async mounted(){
        this.getAdmins()
    }
}
</script>

<style>
</style>